import React from 'react';
import { CameraIcon } from 'lucide-react';
import type { ImageAsset } from '../../types/content';
import { useShowSlotLabels } from '../../contexts/ImageSlotContext';
interface ImageSlotProps {
  image: ImageAsset;
  className?: string;
  imgClassName?: string;
  eager?: boolean;
  decorative?: boolean;
}
export function ImageSlot({
  image,
  className = '',
  imgClassName = '',
  eager,
  decorative
}: ImageSlotProps) {
  const showLabels = useShowSlotLabels();
  const position = /\b(absolute|fixed|sticky)\b/.test(className) ? '' : 'relative';
  if (!image.src) {
    return <div className={`${position} flex flex-col items-center justify-center gap-3 bg-navy text-center brushed ${className}`} role="img" aria-label={image.alt} data-image-slot={image.slot} data-id="element-538" data-mp="25i5z4g01pxrd">
        <span className="flex h-14 w-14 items-center justify-center rounded-full border border-chrome-300/40" data-id="element-539" data-mp="u4aj751bhkz3">
          <CameraIcon className="h-6 w-6 text-chrome-300" aria-hidden="true" data-id="element-540" data-mp="p3d4j2fin92c" />
        </span>
        <span className="px-4 font-display text-sm uppercase tracking-[0.12em] text-chrome-100" data-id="element-541" data-mp="e3azl2hu13u1">{image.slot}</span>
        <span className="text-xs text-chrome-300" data-id="element-542" data-mp="j0t2oc964ou4">Photo slot</span>
      </div>;
  }
  return <div className={`${position} overflow-hidden ${className}`} data-image-slot={image.slot} data-id="element-543" data-mp="511reja1dmjt">
      <img src={image.src} alt={decorative ? '' : image.alt} loading={eager ? 'eager' : 'lazy'} decoding="async" className={`h-full w-full object-cover ${imgClassName}`} data-id="element-544" data-mp="9z3ah47gplva" />
      {showLabels && <span className="absolute left-2 top-2 z-10 rounded-sm bg-ink/85 px-2 py-1 text-[11px] font-medium text-white" data-id="element-545" data-mp="3iggarjmnrqiv">
          Slot: {image.slot}
        </span>}
    </div>;
}